import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import keycode from '../../../constants/keycode';
import { nullable } from '../../../utils/custom-prop-types';

const handleDownKeyPress = (event) => {
    const { target } = event;
    const nextNode = target.parentNode.nextElementSibling;
    const firstNode = target.parentNode.parentNode.firstChild;

    if (nextNode) {
        nextNode.childNodes[0].focus();
    } else {
        firstNode.childNodes[0].focus();
    }
};

const handleUpKeyPress = (event) => {
    const { target } = event;
    const prevNode = target.parentNode.previousSibling;
    const lastNode = target.parentNode.parentNode.lastChild;

    if (prevNode) {
        prevNode.childNodes[0].focus();
    } else {
        lastNode.childNodes[0].focus();
    }
};

class Option extends React.Component {
    constructor(props) {
        super(props);

        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }

    handleKeyDown(event, value) {
        const { onCollapse, onSelect } = this.props;
        const eventKeyCode = event.which || event.keyCode || 0;
        /* eslint-disable default-case */
        switch (eventKeyCode) {
        case keycode.DOWN:
            event.preventDefault();
            handleDownKeyPress(event);
            break;
        case keycode.UP:
            event.preventDefault();
            handleUpKeyPress(event);
            break;
        case keycode.ESC:
            event.preventDefault();
            onCollapse();
            break;
        case keycode.TAB:
            event.preventDefault();
            onSelect(value);
            onCollapse();
            break;
        }
        /* eslint-enable default-case */
    }

    handleKeyPress(event, option) {
        const { onSelect } = this.props;
        const eventKeyCode = event.which || event.keyCode || 0;

        if (eventKeyCode === keycode.ENTER) {
            event.preventDefault();
            onSelect(option);
        }
    }

    render() {
        const {
            isSelected,
            name,
            onSelect,
            value,
        } = this.props;
        const optionClassName = classNames('select__option', {
            'select__option--selected': isSelected,
        });
        const title = name || value;
        return (
            <span
                aria-selected={isSelected}
                className={optionClassName}
                onClick={() => onSelect(value)}
                onKeyDown={event => this.handleKeyDown(event, value)}
                onKeyPress={event => this.handleKeyPress(event, value)}
                role="option"
                tabIndex="-1"
            >
                {title}
            </span>
        );
    }
}

Option.propTypes = {
    isSelected: PropTypes.bool.isRequired,
    name: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.string,
    ]),
    onSelect: PropTypes.func.isRequired,
    onCollapse: PropTypes.func.isRequired,
    value: nullable([
        PropTypes.array,
        PropTypes.number,
        PropTypes.shape({}),
        PropTypes.string,
    ]),
};

Option.defaultProps = {
    name: '',
    value: null,
};

export default Option;
